import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { WaterTestStripSelector } from '../../store/waterTestStrip/waterTestStrip.selector'
import { WaterTestStripActions } from '../../store/waterTestStrip/waterTestStrip.slice'

export type UploadState = 'options' | 'upload' | 'analysis' | 'camera'

export const useUpload = () => {
  const [currentState, setCurrentState] = useState<UploadState>('options')
  const [uploadedFile, setUploadedFile] = useState<File | null>(null)
  const [previewImage, setPreviewImage] = useState<string | null>(null)

  const dispatch = useDispatch() 
  const navigate = useNavigate()
  const loading = useSelector(WaterTestStripSelector.loading)
  const error = useSelector(WaterTestStripSelector.error)

  const handleImageDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0]
    if (file) {
      setUploadedFile(file)
      const reader = new FileReader()
      reader.onload = () => {
        setPreviewImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }, [])

  const resetUpload = () => {
    setUploadedFile(null)
    setPreviewImage(null)
    setCurrentState('options')
    dispatch(WaterTestStripActions.resetWaterTestStripData())
  }
  
  const handleAnalyze = async () => {
    if (!uploadedFile) return
    setCurrentState('analysis')
    await dispatch(WaterTestStripActions.uploadAndAnalyzeImageAsync(uploadedFile) as any)
    setUploadedFile(null)
    setPreviewImage(null)
    navigate('/test-strip/results')
  }

 

  return {
    currentState,
    setCurrentState,
    capturedImage: previewImage,
    isAnalyzing: loading,
    error,
    handleAnalyze,
    handleImageDrop,
    resetUpload,
  }
}
